import { createApp } from 'vue';
import App from './App.vue';
import router from './routes/index.js';
import './assets/css/base.less';
import './assets/js/common';
import { Toast } from 'vant';

import Stat from 'erwan-stat';
import lzReport from '@lz/fe-report';

import VConsole from 'vconsole';
import { getUrlParam, isMiniProgram, clearCookie } from './assets/js/utils';
if (import.meta.env.VITE_APP_ENV !== 'prod') {
    // 如果是非线上环境，加载 VConsole
    new VConsole();
}

window.FpConfig.ready(function () {
    try {
        const statOption = {
            enableAction: true, // 是否开启用户动作监听
            enableError: true, // 是否开启错误监听
            enableXhr: true, // 是否开启Xhr上报
            xhr: {
                includes: [], // 上报的接口规则
                excludes: [
                    'testctai.qn76.cn',
                    'cta.feierlaiedu.com',
                    'arms-retcode.aliyuncs.com',
                    'sentry.feierlaiedu.com',
                    'testkcxtr.qn76.cn',
                    'wrapi.feierlaiedu.com',
                    '/sockjs-node/',
                    'erwan-frontend.cn-zhangjiakou.log.aliyuncs.com',
                    'testlcsg.qn76.cn',
                    'lcsgr.feierlaiedu.com',
                ], // 不上报的接口规则
            },
            enablePerformance: true, // 是否上报性能监控
            elephantId: '875a430a-bbd3-4d02-b332-161b2d2a3061', // 大象项目id
        };
        window.erwan_stat = new Stat(statOption);
        window.erwan_stat.init('qiniu', 'course');
    } catch (e) {}
    try {
        if (window.erwan_stat) {
            window.erwan_stat.customEvent({
                name: 'CustomExpose',
                detail: 'h5AppStartSuccessPv',
                params: {},
            });
        }
    } catch (error) {}

    let { productConfig } = window.FpConfig.data;
    let { VITE_APP_API_CRM_PRE } = productConfig;
    if (import.meta.env.VITE_APP_ENV === 'pre' && VITE_APP_API_CRM_PRE) {
        productConfig.VITE_APP_API_CRM = VITE_APP_API_CRM_PRE;
    }
    window.productConfig = productConfig;
    console.log('window.productConfig');
    console.log(window.productConfig);
    const query = getUrlParam();

    try {
        const needBindMajorSubjectOnff = sessionStorage.getItem('needBindMajorSubject');
        if (isMiniProgram() && query.needBindMajorSubject && needBindMajorSubjectOnff !== 'true') {
            localStorage.clear();
            sessionStorage.clear();
            clearCookie();
            sessionStorage.setItem('needBindMajorSubject', 'true');
        }
    } catch (error) {
        console.log(error);
    }

    if (isMiniProgram() && query.token) {
        localStorage.setItem('token', query.token);
    }

    window.lzReport = lzReport.init({
        systemCode: 10002,
        env: import.meta.env.VITE_APP_ENV,
    });
    if (isMiniProgram() && query.customerId) {
        window.lzReport.setConfig({
            customerId: query.customerId,
        });
    }
    if (query.launchUUId) {
        try {
            window.lzReport.report({
                process: 'wechatApplet',
                eventType: `${query.hostType || 'billing-mini'}-success`,
                extend: JSON.stringify({
                    url_host: window.location.origin,
                    uuid: query.launchUUId,
                }),
                reason: window.location.origin,
            });
        } catch (error) {
            console.log(error);
        }
    }
    if (query.authUUID && query.authDomain) {
        try {
            window.lzReport.report({
                process: 'wechatApplet',
                eventType: `billing-auth-success`,
                extend: JSON.stringify({
                    url_host: decodeURIComponent(query.authDomain),
                    uuid: query.authUUID,
                }),
                reason: decodeURIComponent(query.authDomain),
            });
        } catch (error) {
            console.log(error);
        }
    }

    const app = createApp(App);
    app.directive('focus', {
        mounted(el) {
            el.focus();
        },
    });
    app.directive('enterMoney', {
        // 自定义指令名字 v-enter-money
        mounted: function (el, { value = 2 }) {
            el = el.nodeName == 'INPUT' ? el : el.children[0];
            let RegStr = value == 0 ? `^[\\+\\-]?\\d+\\d{0,0}` : `^[\\+\\-]?\\d+\\.?\\d{0,${value}}`;
            el.addEventListener('keyup', function () {
                el.value = el.value.match(new RegExp(RegStr, 'g'));
                el.dispatchEvent(new Event('input'));
            });
        },
    });
    app.use(Toast);

    app.use(router).mount('#app');
});
